import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const confirmEmailChangeSchema = z.object({
  token: z.string().min(1),
});

export class ConfirmEmailChangeDto extends createZodDto(confirmEmailChangeSchema) {}
